
import { Link, useLocation } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton
} from "@/components/ui/sidebar";
import { MessageSquare } from "lucide-react";

export const PatientSidebar = () => {
  const location = useLocation();
  console.log("PatientSidebar - Current path:", location.pathname);
  
  // Use improved path checking for active state
  const isActive = (path: string) => {
    // Exact match
    if (location.pathname === path) {
      return true;
    }
    
    // For other paths, check if it's a parent path
    return location.pathname.startsWith(path + "/");
  };

  return (
    <Sidebar>
      <SidebarHeader className="flex items-center justify-center p-4">
        <Link to="/patient-discussion" className="flex items-center">
          <img
            src="/lovable-uploads/21086736-4e89-4e97-93a1-7f8113b89223.png"
            alt="Forge Medical Practice Logo"
            className="h-8 mr-2"
          />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild isActive={isActive("/patient-discussion")}>
              <Link to="/patient-discussion">
                <MessageSquare className="h-4 w-4" />
                <span>Patient Discussion</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarContent>
    </Sidebar>
  );
};
